"use strict";
import tippy from "tippy.js";

export const shareButtons = (message) => ({
    message,
    open: false,
    hasShareApi: !!navigator.share,
    copyToClipboard() {
        navigator.clipboard.writeText(window.location.href).then(() => {
            tippy(this.$el, {
                trigger: 'manual',
                content: this.$el.getAttribute('data-tippy-content') || 'Link copied!',
                placement: 'top-start',
                arrow: false,
            }).show();

            setTimeout(() => {
                this.$el._tippy.hide(); // Nasconde il tooltip dopo 2 secondi
            }, 2000);
        }).catch(err => console.error('Error copying the link:', err));
    },
    shareOnFacebook() {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), '_blank', 'width=600,height=400')
    },
    shareOnTwitter() {
        window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href) + '&text=' + encodeURIComponent(this.message), '_blank', 'width=600,height=400')
    },
    shareOnWhatsApp() {
        window.open('https://api.whatsapp.com/send?text=' + encodeURIComponent(`${this.message} ${window.location.href}`), '_blank', 'width=600,height=400');
    },
    shareApi() {
        navigator.share({
            title: document.title,
            text: this.message,
            url: window.location.href
        }).catch(err => console.error('Sharing error:', err));
    }

})